import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { BACKEND_ROOT_URL } from "../../../../api";
import { useCookies } from "../../../../hooks/useCookies";
import { useSocket } from "../../../../Context/SockerContext";

const ProfileContext = createContext();

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error("useProfile must be used within a ProfileProvider");
  }
  return context;
};

export default function ProfileProvider({ children }) {
  const { getCookie, setCookie } = useCookies();
  const userId = getCookie("userId");

  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);

  const { socket } = useSocket();

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!socket) return;
    socket.on("user_socket_emit", data => {
      if (data?.userId === userId && data?.event === "fetch_user_data") {
        fetchProfile();
      }
    });
  }, [socket, userId]);

  const fetchProfile = async () => {
    const token = getCookie("token");
    if (!token) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${BACKEND_ROOT_URL}/api/v2/user/getMe`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data?.data) {
          setProfile(data.data);
          setCookie("Name", data?.data?.Name, 30);
          return { data: data.data, ok: true };
        }
      } else {
        console.error("Error fetching profile");
      }
    } catch (err) {
      console.error("Something went wrong", err);
    } finally {
      setLoading(false);
    }
    return false;
  };

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchProfile();
      hasFetchedRef.current = true;
    }
  }, []);

  const updateProfile = type => {
    if (type === "update") {
      fetchProfile();
    }
  };
  const clearProfile = () => {
    setProfile();
  };

  return (
    <ProfileContext.Provider
      value={{ profile, fetchProfile, updateProfile, loading, clearProfile }}
    >
      {children}
    </ProfileContext.Provider>
  );
}
